import { useRef, useEffect, useCallback } from "react";
const useAbortController = () => {
  const lastAbortControllerRef = useRef(void 0);
  useEffect(() => () => {
    lastAbortControllerRef.current?.abort();
  }, []);
  return useCallback(() => {
    lastAbortControllerRef.current?.abort();
    const newController = new AbortController();
    lastAbortControllerRef.current = newController;
    return newController.signal;
  }, []);
};
export {
  useAbortController
};
//# sourceMappingURL=useAbortController.js.map
